import { TopBar, Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { PageMeta, BreadcrumbJsonLd } from '@/components/PageMeta';
import { PageHero } from '@/components/PageHero';
import { ScrollProgressBar } from '@/components/ScrollProgressBar';
import { BOX_IMAGES } from '@/data/images';

export default function MentionsLegalesPage() {
  return (
    <div className="min-h-screen">
      <PageMeta
        title="Mentions légales"
        description="Mentions légales de CrossFit Saint-Chamond — HYROX Training Club. 7 Rue Jean-Jacques Rousseau, 42400 Saint-Chamond."
        path="/mentions-legales"
      />
      <BreadcrumbJsonLd items={[{ name: 'Accueil', url: '/' }, { name: 'Mentions légales' }]} />
      <ScrollProgressBar />
      <TopBar />
      <Navigation />

      <PageHero
        pageKey="/mentions-legales"
        eyebrow="Informations légales"
        title="MENTIONS LÉGALES"
        highlight="LÉGALES"
        subtitle="Informations légales et éditoriales relatives au site crossfit-saintchamond.fr"
        image={BOX_IMAGES.barbellPrep}
        alt="Mentions légales CrossFit Saint-Chamond"
        breadcrumbs={[{ name: 'Accueil', href: '/' }, { name: 'Mentions légales' }]}
        minHeight="min-h-[40vh]"
      />

      <section className="section-padding bg-white" data-testid="mentions-legales-content">
        <div className="container-custom max-w-3xl prose prose-neutral">
          <h2 className="font-heading text-2xl text-dark mt-8 mb-4 tracking-wide">1. Éditeur du site</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            <strong>Raison sociale :</strong> NP Activités Physiques Sports Santé (nom commercial <em>CrossFit Saint-Chamond</em>)<br />
            <strong>Forme juridique :</strong> EURL (Entreprise Unipersonnelle à Responsabilité Limitée)<br />
            <strong>Capital social :</strong> 5&nbsp;000&nbsp;€<br />
            <strong>Siège social :</strong> 7 Rue Jean-Jacques Rousseau, 42400 Saint-Chamond, France<br />
            <strong>SIREN :</strong> 101&nbsp;447&nbsp;928<br />
            <strong>SIRET :</strong> 101&nbsp;447&nbsp;928&nbsp;00017<br />
            <strong>RCS :</strong> Saint-Étienne — 101 447 928<br />
            <strong>N° TVA intracommunautaire :</strong> FR88&nbsp;101&nbsp;447&nbsp;928<br />
            <strong>Code APE/NAF :</strong> 85.51Z (Enseignement de disciplines sportives et d'activités de loisirs)<br />
            <strong>Email :</strong> <a href="mailto:crossfit.saintchamond@gmail.com" className="text-primary">crossfit.saintchamond@gmail.com</a><br />
            <strong>Directeur de la publication :</strong> Nicolas Perroy (Gérant)
          </p>

          <h2 className="font-heading text-2xl text-dark mt-10 mb-4 tracking-wide">2. Hébergement</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Le site est hébergé sur l'infrastructure Emergent (Emergent Labs).<br />
            Pour toute question relative à l'hébergement, merci de contacter l'éditeur.
          </p>

          <h2 className="font-heading text-2xl text-dark mt-10 mb-4 tracking-wide">3. Propriété intellectuelle</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            L'ensemble des contenus du site (textes, photos, logos, illustrations, vidéos) est la propriété exclusive de CrossFit Saint-Chamond ou de ses partenaires. Toute reproduction, représentation, modification ou diffusion — totale ou partielle — sans autorisation écrite préalable est strictement interdite et susceptible de constituer une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.
          </p>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Les marques « CrossFit® » et « HYROX® » appartiennent à leurs propriétaires respectifs. CrossFit Saint-Chamond est affilié CrossFit et HYROX Training Club.
          </p>

          <h2 className="font-heading text-2xl text-dark mt-10 mb-4 tracking-wide">4. Responsabilité</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Les informations présentées sur ce site sont fournies à titre indicatif. Malgré le soin apporté à leur mise à jour, l'éditeur ne peut garantir l'exactitude, la complétude ou l'actualité des informations diffusées. L'utilisateur reconnaît utiliser ces informations sous sa seule responsabilité.
          </p>
          <p className="text-muted-foreground text-sm leading-relaxed">
            La pratique du CrossFit et du HYROX implique une activité physique intense. Il est recommandé de consulter un médecin avant de débuter toute activité sportive, particulièrement en cas d'antécédents médicaux.
          </p>

          <h2 className="font-heading text-2xl text-dark mt-10 mb-4 tracking-wide">5. Liens hypertextes</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Le site peut contenir des liens vers des sites tiers (Deciplus pour la réservation, Google Maps, Instagram, Facebook). CrossFit Saint-Chamond n'exerce aucun contrôle sur le contenu de ces sites et décline toute responsabilité quant à leur accessibilité ou leurs pratiques.
          </p>

          <h2 className="font-heading text-2xl text-dark mt-10 mb-4 tracking-wide">6. Médiation de la consommation</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Conformément à l'article L.616-1 du Code de la consommation, le consommateur a le droit, pour tout litige contractuel non résolu à l'amiable, de recourir gratuitement à un médiateur de la consommation. Vous pouvez saisir la plateforme européenne de règlement en ligne des litiges : <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-primary">ec.europa.eu/consumers/odr</a>.
          </p>

          <h2 className="font-heading text-2xl text-dark mt-10 mb-4 tracking-wide">7. Droit applicable</h2>
          <p className="text-muted-foreground text-sm leading-relaxed">
            Les présentes mentions légales sont régies par le droit français. Tout litige relatif à leur interprétation ou à leur exécution relève de la compétence des tribunaux français.
          </p>

          <p className="text-muted-foreground text-xs mt-12 italic">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long' })}.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
